module.exports = __webpack_public_path__ + "static/media/PROSTHODONTICSSYllabus.fa3cec11.docx";